module.exports = __webpack_public_path__ + "static/img/2345_img_2.c11487e1.png";